// extracted by mini-css-extract-plugin
export default {"column__text":"styles_column__text__TvcGh","pagination__wrapper":"styles_pagination__wrapper__9mNCN","pagination__container":"styles_pagination__container__U6Jsg"};